"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const changeSidePanel_1 = require("../../actions/app/changeSidePanel");
const Header_1 = __importDefault(require("./Header"));
const CloseButton_1 = __importDefault(require("../shared/CloseButton"));
const CreateGroupChatIcon_1 = __importDefault(require("../shared/CreateGroupChatIcon"));
const NameInput_1 = __importDefault(require("../shared/NameInput"));
const joinGroup_1 = __importDefault(require("../../actions/chats/joinGroup"));
const panels_1 = require("../../domain/model/panels");
const PLACEHOLDER_TEXT = "Invite Code";
exports.default = react_1.default.memo(JoinGroupChatPanel);
const useStyles = makeStyles_1.default((theme) => ({
    nameInput: {
        marginTop: 60,
        marginLeft: 30
    },
    cancelButton: {
        color: colorManipulator_1.alpha(theme.colors.header.primaryTextColor, 0.6)
    }
}));
function JoinGroupChatPanel() {
    const dispatch = react_redux_1.useDispatch();
    const classes = useStyles();
    function closePanel() {
        dispatch(changeSidePanel_1.changeLeftPanel(panels_1.LeftPanelType.Chats));
    }
    function handleSubmit(text) {
        closePanel();
        const chatId = BigInt("0x" + text);
        dispatch(joinGroup_1.default(chatId));
    }
    const newChatIcon = react_1.default.createElement(CreateGroupChatIcon_1.default, { size: "sm" });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Header_1.default, { leftIcon: newChatIcon, title: "Join a group", rightIcon: react_1.default.createElement(CloseButton_1.default, { onClick: closePanel, className: classes.cancelButton }) }),
        react_1.default.createElement(NameInput_1.default, { onSubmit: handleSubmit, placeholderText: PLACEHOLDER_TEXT, minLength: 32, maxLength: 32, className: classes.nameInput })));
}
